import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetch_restaurant_details, save_restaurant_details } from './api';
import type { RestaurantDetailsRequest } from './types';

const KEY = ['module-details', 'restaurant'] as const;

export function use_save_restaurant_details() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: RestaurantDetailsRequest) => save_restaurant_details(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['onboarding', 'draft'] });
      qc.invalidateQueries({ queryKey: KEY });
    },
  });
}

export function use_restaurant_details(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: KEY,
    queryFn: fetch_restaurant_details,
    staleTime: 0,
    retry: 0,
    enabled: options?.enabled ?? true,
  });
}
